// extracted by mini-css-extract-plugin
module.exports = {"root":"Home_root__2KVHO","expand":"Home_expand__iK_dw"};